import { Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-product-badges",
    templateUrl: "./product-badges.component.html",
    styleUrls: ["./product-badges.component.css"],
    imports: [CommonModule],
})
export class ProductBadgesComponent {
    product = input<any>();
}
